/**
 * Projects Grid
 * Manages the 3/2 column toggle for the projects listing page.
 */

document.addEventListener('alpine:init', () => {
  window.Alpine.data('projectsGrid', ({ cols = 'three' } = {}) => ({
    cols,

    setCols(next) {
      this.cols = next;
    },
  }));
});
